export default "__VITE_ASSET__Ea6EMQXZ__"